module.exports = __webpack_public_path__ + "static/img/param_xiongdi.b2138c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/param_xiongdi.png
// module id = C2SD
// module chunks = 0